/// <summary>
/// 起终点、途经点及驾车方案信息 oyyh,20161008添加注释
/// </summary>
export class DriveParameters {

	constructor() {

		/// <summary>
		/// 终点
		/// </summary>
		this.dest = null;
		this.height = null;
		this.key = null;
		/// <summary>
		/// 中点
		/// </summary>
		this.mid = null;
		/// <summary>
		/// 起点
		/// </summary>
		this.orig = null;
		this.sort = null;
		this.style = null;
		/// <summary>
		/// 版本
		/// </summary>
		this.version = null;
		this.width = null;
	}



	static GetDriveParameters(objProxy) {
		let params=null;
		if(objProxy==null)return params;
		params=new DriveParameters();
		params.dest = objProxy.dest;
		params.height = objProxy.height;
		params.key = objProxy.key ;
		params.mid = objProxy.mid;
		params.orig = objProxy.orig;
		params.sort = objProxy.sort;
		params.style = objProxy.style;
		params.version = objProxy.version;
		params.width = objProxy.width;

		return params;
	}

}

